import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { XCircle } from 'lucide-react';

export default function PaymentCancel() {
  return (
    <main className="min-h-screen grid place-items-center bg-background px-4" data-testid="payment-cancel-page">
      <div className="max-w-md w-full bg-card border border-border rounded-xl p-8 text-center card-shadow space-y-4">
        <div className="flex justify-center"><XCircle className="h-12 w-12 text-muted-foreground" /></div>
        <h1 className="text-xl font-bold" data-testid="payment-cancel-title">Pago cancelado</h1>
        <p className="text-sm text-muted-foreground">No se realizó ningún cargo. Puedes retomar el pago cuando quieras desde tu panel.</p>
        <Button asChild className="w-full bg-brand-orange text-white hover:bg-brand-orange-dark" data-testid="payment-cancel-back"><Link to="/seller/subscription">Volver a mi suscripción</Link></Button>
      </div>
    </main>
  );
}
